import { createUseStyles } from "react-jss";
import { ITheme } from "../../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  hideHeader: {
    transform: "translate(0px, -100%)",
    transition: "all ease-in-out 1s",
  },
}));
